import React, { useEffect, useId, useMemo, useRef } from 'react';
import { usePremium } from '../../premium/PremiumContext';

const ADS_GEN_1 = {
  name: 'adsGen1',
  variableName: 'mhr',
  src: '//deliciouslip.com/b.XzVjscd/GQl/0/Y/WEcy/beBmC9cudZeU/l/kaP/Thc_xLMWzREYy/N/DLk/tyNWzmEPztMRTLI/1LMHwk'
};

const AD_SCRIPTS = {
  adsGen1: ADS_GEN_1,
  home: {
    name: 'home',
    variableName: 'nvpo',
    src: '//superbjudgment.com/b_XQV.sCdiGLlE0ZYDW/cK/ae/m_9/u/ZGU/lVk/PWTmYi5RMDzTcew/NQD/Emt/NCjEkdz/Npz/AG0DN_QE'
  },
  homeBottom: {
    name: 'homeBottom',
    variableName: 'nvpo',
    src: '//superbjudgment.com/b.X/VAsEdyGylM0/Y/W/cE/Xe/m-9CuYZHUwl_kLPST-Yo5FN/ToM/3/MQz/MAtyNGjykc1TMGzGcqzZN/wP'
  },
  adminPage: {
    name: 'adminPage',
    variableName: 'hvg',
    src: '//superbjudgment.com/bQX.Vos/dNGtlA0WY-WucB/EeomL9aufZPU/lDk/PzTLY/5TNkTNM/3/Nxj/UHtJNkj/kY1YM/zacN2fOvQp'
  },
  profile: {
    name: 'profile',
    variableName: 'kkjlr',
    src: '//superbjudgment.com/bQX.Vos/dNGtlA0WY-WucB/EeomL9aufZPU/lDk/PzTLY/5TNkTNM/3/Nxj/UHtJNkj/kY1YM/zacN2fOvQp'
  },
  general: {
    name: 'general',
    variableName: 'dcejv',
    src: '//superbjudgment.com/bsX.VNs/drGhlt0tYQWFct/bejmf9KuzZEUVlWk/P/Ttc/wtM/DeAB4-NJjPEDtlNDzTA/wtM/DPgM2fNyQx'
  }
};

export default function SectionAd({ placement = 'adsGen1', className = 'd-flex justify-content-center my-4' }) {
  const containerRef = useRef(null);
  const scriptLoadedRef = useRef(false);
  const reactId = useId();
  const { isPremium, premiumLoading } = usePremium();
  const adConfig = AD_SCRIPTS[placement] || AD_SCRIPTS.adsGen1;
  const containerId = useMemo(
    () => `section-ad-${adConfig.name}-${reactId.replace(/[:]/g, '')}`,
    [adConfig.name, reactId]
  );

  useEffect(() => {
    if (premiumLoading || isPremium || !adConfig || scriptLoadedRef.current || !containerRef.current) {
      return;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = `(function(${adConfig.variableName}){\nvar d = document,\n    s = d.createElement('script'),\n    l = d.scripts[d.scripts.length - 1];\ns.settings = ${adConfig.variableName} || {};\ns.src = "${adConfig.src}";\ns.async = true;\ns.referrerPolicy = 'no-referrer-when-downgrade';\nl.parentNode.insertBefore(s, l);\n})({})`;

    containerRef.current.appendChild(script);
    scriptLoadedRef.current = true;
  }, [adConfig, isPremium, premiumLoading]);

  if (premiumLoading || isPremium) {
    return null;
  }

  return (
    <div className={className}>
      <div className="text-center">
        <div className="text-center mb-2">
          <span
            className="text-uppercase"
            style={{
              fontSize: '0.7rem',
              fontWeight: '600',
              letterSpacing: '1px',
              color: 'var(--brand-secondary, #ffc107)',
              background: 'rgba(0,0,0,0.5)',
              padding: '2px 8px',
              borderRadius: '20px',
              display: 'inline-block',
              marginBottom: '4px'
            }}
          >
            <i className="bi bi-star-fill me-1" style={{ fontSize: '0.6rem' }}></i>
            Pubblicità
          </span>
          <div id={containerId} ref={containerRef}></div>
        </div>
      </div>
    </div>
  );
}
